import React from 'react'
import { func, array, boolean } from 'prop-types'
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right'
import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left'
import styles from './StravaListActivities.styl'


export default class StravaListActivities extends React.Component {

	static propTypes = {
		handlePageFetch: func,
		handleActivityFetch: func,
		pages: array,
		processing: boolean
	}

	constructor(props) {
		super(props)
		const loading = new Array(10).fill('').map((ele, i) => (
			<li key={ i } className={ styles['loading'] }>
				<span style={ { minWidth: `${ Math.random() * (75 - 25) + 25 }%` } } className={ styles['loading-bar'] } />
			</li>))
		this.state = { page: 1, active: null, loading }
		this.handlePageChange = this.handlePageChange.bind(this)
	}
	componentDidMount() {
		const { handlePageFetch } = this.props
		handlePageFetch(1)
	}
	handlePageChange(direction, page) {
		const { handlePageFetch } = this.props
		switch (direction) {
			case 'left':
				if (page > 1) {
					this.setState({ page: page - 1 })
					handlePageFetch(page - 1)
				}
				break
			case 'right':
				this.setState({ page: page + 1 })
				handlePageFetch(page + 1)
				break
			default:
				break
		}
	}

	// createActiveClassName(active, processing) {
	// 	let className = ''
	// 	if (active) {
	// 		className += styles['active']
	// 	}
	// 	if (processing) {

	// 	}
	// 	return className
	// }

	computePageToList(page, handleActivityFetch, processing) {
		return (page || []).map((ele, index) => (
			<li
				key={ index } className={ this.state.active === index ? styles['active'] : '' } onClick={ () => {
					this.setState({ active: index })
					handleActivityFetch(ele.id)
				} }
			>{ ele.start_date_local.split('T')[0] } - { ele.name }
				{ processing && this.state.active === index ? <div className={ styles['loader'] } /> : null }
			</li>
		))
	}

	computeActivities(pages, handleActivityFetch, loading, processing) {
		if (!pages) {
			return loading
		} else if (pages && !pages.length) {
			return <li>Não existe informação para esta página!</li>
		}
		return this.computePageToList(pages, handleActivityFetch, processing)
	}

	render() {
		const { page, loading } = this.state
		const { pages, handleActivityFetch, processing } = this.props

		return (
			<div className={ styles['lists'] }>
				<ul>
					{ this.computeActivities(pages, handleActivityFetch, loading, processing) }
					<li>
						<FaArrowCircleLeft className={ styles['arrow'] } onClick={ () => this.handlePageChange('left', page) } />
						{ pages && !pages.length ? null : <FaArrowCircleRight className={ styles['arrow'] } onClick={ () => this.handlePageChange('right', page) } /> }
					</li>
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/StravaListActivities/StravaListActivities.js